<template>
    <div class="page">
        <map-editor/>
        <editor type="roads"/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import MapEditor from './_map'
import Editor from './_editor'
import API from '@/service/plate_editor'
export default {
    components: {
        MapEditor,
        Editor
    },
    computed: mapState({
        list: state => state.PlateEditor.list,
    }),
    async mounted () {
        console.log(this.$route)
        const { plate_id, plate_facility_id } = this.$route.params
        const { data } = await API.getPlateRoads(plate_id, plate_facility_id)
        console.log(data)
        setTimeout(() => {
            this.$store.dispatch('PlateEditor/openRoadsEdit', data)
        }, 1500)
    }
}
</script>
<style lang="scss" scoped>
.page {
    display: flex;
    width: 100%;
    height: 100vh;
}
</style>
